import { lazy, memo, Suspense } from "react";
import { Button } from "react-bootstrap";
import "../css/SupportUs.css";

const CommonVideoPlayer = lazy(() => import("../common/common-video-player"));
const ContributionCard = lazy(() => import("./ContributionCard"));

const BANNER_STYLE: React.CSSProperties = {
  backgroundImage: "url('/Vision-Landing.png')",
};
const BTN_STYLE: React.CSSProperties = {
  backgroundColor: "#3899a2",
  border: "1px solid white",
};
const FALLBACK_STYLE: React.CSSProperties = { minHeight: 200 };
const IMG_ASPECT_WIDTH = 800;
const IMG_ASPECT_HEIGHT = 600;

function SupportUsInner() {
  return (
    <div className="w-100">
      <div
        className="banner py-5 d-flex w-100 flex-column justify-content-between align-items-center"
        style={BANNER_STYLE}
      >
        <div className="p-2 p-md-5">
          <h1>Support Our Growth</h1>
          <p className="fs-3 fw-semibold">
            Your support helps Muslims businesses and professionals thrive, not
            just in the UK, but worldwide. Join us in making a difference.
          </p>
        </div>
      </div>
      <div className="container py-4">
        <div className="row gap-4 gap-md-0">
          <div className="col-md-6">
            <h2>How Your Support Helps</h2>
            <h5>Expand Mentorship Programs</h5>
            <p>
              We’re introducing new 1-on-1 and group mentorship opportunities
              through the Muslim Mentor Academy.
            </p>
            <h5>Enhance Business Support</h5>
            <p>
              We’re developing additional resources for the Muslim Business
              Accelerator and Muslim Career Accelerator.
            </p>
            <h5>Assist More Businesses and Professionals</h5>
            <p>
              Your contribution helps more businesses and professionals access
              the services they need to grow within the Muslim community.
            </p>
            <h5>Invest in Future Leaders</h5>
            <p>
              We’re providing more educational resources and investment
              opportunities through Muslim Invest and Muslim Venture Builder.
            </p>
          </div>
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <Suspense fallback={<div style={FALLBACK_STYLE} aria-hidden="true" />}>
              <CommonVideoPlayer
                backgroundImage="url(/SMBF.png)"
                src="/video.mp4"
              />
            </Suspense>
          </div>
        </div>
      </div>
      <div className="gradient-bg py-5 text-center d-flex flex-column align-items-center justify-content-center fs-3 px-2 px-md-5 text-white">
        <h2 className="px-md-5">Contribute today and be part of the growth.</h2>
        <p className="px-md-5  fs-3">
          Your support directly impacts the success of Muslim businesses and
          professionals Not Just in The UK but Globally.
        </p>
        <Button
          type="submit"
          className="btn px-5 rounded-pill fw-bold text-white"
          style={BTN_STYLE}
        >
          CONTRIBUTE NOW
        </Button>
      </div>
      <div className="secondary-bg">
        <div className="container secondary-bg py-4">
          <div className="row gap-4 gap-md-0">
            <div className="col-md-5 p-md-2 d-flex justify-content-center align-items-center">
              <img
                className="img-fluid w-100 image h-100 rounded-4"
                src="/SMBF-17.png"
                alt="Our impact – empowering the ummah"
                width={IMG_ASPECT_WIDTH}
                height={IMG_ASPECT_HEIGHT}
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="col-md-7 p-md-5 d-flex justify-content-center flex-column">
              <h2>Our Impact</h2>
              <h5>Empowering The Ummah</h5>
              <p>
                Your support helps transform businesses and professionals,
                empowering the ummah economically. Our impact showcases the
                tangible results of your contributions and the success stories
                of our members.
              </p>
              <h5>Boosting Trade</h5>
              <p>
                Facilitating over 8 figures in international trade, we’ve
                significantly bolstered the Muslim economy and paved the way for
                sustainable growth.
              </p>
              <h5>Business Incubation</h5>
              <p>
                Our expert team has nurtured and supported over 100 businesses,
                providing the essential tools and resources needed for success.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="m-4 py-4 row border contribution-container-bg p-2 p-md-3 rounded-4">
        <div className="col-md-6 py-md-5 text-white">
          <h2>Contribute today and be part of the growth.</h2>
          <p className="fs-4">
            Your support directly impacts the success of Muslim businesses and
            professionals worldwide.
          </p>
        </div>
        <div className="col-md-6">
          <Suspense fallback={<div style={FALLBACK_STYLE} aria-hidden="true" />}>
            <ContributionCard />
          </Suspense>
        </div>
      </div>
    </div>
  );
}

SupportUsInner.displayName = "SupportUs";

export default memo(SupportUsInner);
